<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title>City Master</mat-card-title>
    <button mat-fab  [ngClass]="isAdminGroupUser ? 'mat-mini-fab mat-accent' : 'mat-mini-fab mat-button-disabled'"
    (click)="openDialog()"  color="accent" style="position:absolute; right:10px;top:8px;width: 35px; height:35px;"
    matTooltip="Add City">
    <span class="mat-mdc-button-wrapper">
      <i   class="material-icons" style="font-size:30px;">add</i>
    </span>
  </button>
    <button mat-fab  (click)="exportExcel()"  color="accent" style="position:absolute;right:50px;top:8px;width:35px;height:35px;"
    *ngIf="cities != null && cities.length >0" matTooltip="Download Records">
    <span class="mat-mdc-button-wrapper">
      <i   class="material-icons" style="font-size:30px;">download</i>
    </span>
  </button>
    <mat-card-subtitle></mat-card-subtitle>
    <mat-card-content>
           <div class="row">
      <div class="col-md-9">
      </div>
      <div class="col-md-3">
          <app-filter-input *ngIf="cities!=null && cities.length >0" (filterChanged)="applyFilter($event)"></app-filter-input>
      </div>
    </div>
  <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort
        (matSortChange)="announceSortChange($event)" *ngIf="cities != null"
        aria-label="Table listing cities">
        <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef> S No. </th>
          <td mat-cell *matCellDef="let element; let i= dataIndex;">
            {{dataSource.filteredData.indexOf(element) + 1}}
          </td>
        </ng-container>

        <!-- cityId Column hidden -->
        <ng-container matColumnDef="cityId">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let element"> {{element.cityId}} </td>
        </ng-container>
        <!-- stateId Column hidden -->
        <ng-container matColumnDef="stateId">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let element"> {{element.stateId}} </td>
        </ng-container>
        <!-- stateName Column -->
        <ng-container matColumnDef="stateName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by stateName"> State Name
          </th>
          <td mat-cell *matCellDef="let element"> {{element.stateName}} </td>
        </ng-container>
        <!-- cityname Column -->
        <ng-container matColumnDef="cityName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by cityName"> City Name
          </th>
          <td mat-cell *matCellDef="let element"> {{element.cityName}} </td>
        </ng-container>
        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef> Edit </th>
          <td mat-cell *matCellDef="let element">
            <button mat-mini-fab aria-label="Edit"  [disabled] ="!isAdminGroupUser" (click)="updateCity($event, element)">
              <mat-icon>create</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef> Delete </th>
          <td mat-cell *matCellDef="let element">
            <button mat-mini-fab aria-label="Delete" [disabled]="!isAdminGroupUser"
              (click)="softDelete($event, element)" color="warn">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [length]=resultLength pageSize="25" [pageSizeOptions]="[25, 50, 100]"  aria-label="Select page"></mat-paginator>
      <div *ngIf="isLoaderResult"  class="custSpinner"> 
      </div>
  </div>
    </mat-card-content>

  </mat-card>

</div>